import { SerpSeasonEndSnapshot } from '@/components/Approval/@components/SerpSeasonEnd';
import { parseSerpContent } from '@/utils/approval/serpDocument';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 174 SERP 시즌마감 조정 — 저장 content 그대로(레거시 조회와 동일), 「정산내역보기」는 저장된 모달 내용 */
const SerpSeasonEndSlot = ({ data }: ContentExtraProps) => {
  const content = parseSerpContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <SerpSeasonEndSnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default SerpSeasonEndSlot;
